import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' }) <PropsType>`
    height: auto;
`;

export const BresBetLogo = observer('BresBetLogo', ({ className, onClick }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        onClick={onClick}
        width='122'
        height='20'
        viewBox='0 0 122 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill='#ED3FAA'
            d='M.211.72h8.54c5.124 0 7.33 1.485 7.33 4.733 0 2.475-1.429 3.805-4.07 4.393v.279c3.572.309 4.721 1.392 4.721 4.052 0 3.093-1.987 5.104-7.111 5.104H.21V.72Zm5.59 4.146V8.33h2.857c1.522 0 2.112-.464 2.112-1.763 0-1.206-.528-1.7-2.019-1.7h-2.95v-.001Zm0 7.145v3.248h3.633c1.212 0 1.77-.619 1.77-1.609 0-1.113-.372-1.639-1.863-1.639h-3.54ZM26.11 13.557h-2.05v5.723h-5.59V.72h8.572c4.907 0 7.64 2.073 7.64 6.527 0 2.722-1.18 4.485-3.168 5.444l4.255 6.248v.34h-6.49l-3.168-5.722ZM24.06 5.36v4.145h2.672c1.832 0 2.422-.65 2.422-2.073 0-1.515-.776-2.072-2.515-2.072h-2.578ZM36.98.72h14.844v4.795h-9.255V7.99h8.633v3.929H42.57v2.567h9.255v4.794H36.98V.72ZM53.5 14.021l5.31-1.144c.405 1.824 1.864 2.475 3.541 2.475 1.491 0 2.33-.34 2.33-1.176 0-.928-.653-1.484-4.007-2.01-5.186-.774-6.77-2.846-6.77-6.094 0-3.743 2.609-5.816 8.044-5.816 5.434 0 7.515 2.29 7.95 5.382l-5.56 1.052c-.31-1.454-.9-2.197-2.7-2.197-1.492 0-2.206.433-2.206 1.3 0 .742.28 1.33 3.665 1.887C69.153 8.7 70.3 11.05 70.3 13.835c0 3.743-2.453 5.909-8.199 5.909-6.428 0-8.26-2.784-8.601-5.723ZM72.32.72h8.54c5.123 0 7.328 1.485 7.328 4.733 0 2.475-1.428 3.805-4.068 4.393v.279c3.571.309 4.72 1.392 4.72 4.052 0 3.093-1.987 5.104-7.111 5.104h-9.41V.72Zm5.59 4.145V8.33h2.856c1.522 0 2.112-.464 2.112-1.763 0-1.207-.528-1.701-2.019-1.701h-2.95Zm0 7.146v3.248h3.633c1.21 0 1.77-.62 1.77-1.61 0-1.113-.373-1.638-1.864-1.638h-3.54ZM90.58.72h14.843v4.795h-9.255V7.99h8.634v3.929h-8.634v2.567h9.255v4.794H90.579V.72ZM106.385.72h15.404v5.104h-4.907V19.28h-5.59V5.824h-4.907V.72Z'
        />
    </SvgElement>
));
